import React from 'react';
import classNames from 'classnames';

import { ClickableDiv } from '../../index';

import styles from './FilterButton.module.scss';

type Props = {
    isActive: boolean;
    name: string;
    className?: string;
    activeClassName?: string;
    onClick: (val: MouseEvent) => void;
}

const FilterButton = ({ isActive, name, className, activeClassName, onClick }: Props) => (
  <ClickableDiv
    onClick={onClick}
    className={classNames(
      className,
      styles.filterButton,
      isActive && activeClassName,
      { [styles.active]: isActive },
    )}
  >
    {name}
  </ClickableDiv>
);

export default FilterButton;
